<template>
  <div class="col-md-12 pa-0 service-usage">
    <div class="row ma-0">
      <div class="col-md-6 col-12 pl-0 py-0" v-for="card in cards" :key="card.key">
        <div class="service-card">
          <div class="icon-box">
            <div class="icon-img">
              <span class="material-icons" :style="{ backgroundColor: card.tint, color: card.color }">
                {{ card.icon }}
              </span>
            </div>
            <div class="text">
              <h1>
                <v-progress-circular v-if="loading" indeterminate :size="16" :width="2" color="#ccc" />
                <template v-else>{{ card.total }}</template>
              </h1>
              <p>{{ card.label }}</p>
              <small v-if="!loading">{{ card.detail }}</small>
            </div>
            <v-btn icon small class="refresh" :disabled="loading" @click="fetch">
              <v-icon small>autorenew</v-icon>
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    usage: {
      transport: { total: 0 },
      food: { total: 0 },
      batches: [],
    },
  }),

  computed: {
    /**
     * Both belong to an enrollment, and an enrollment belongs to one batch, so
     * each card carries its split across the live batches.
     */
    cards() {
      const { transport, food, batches } = this.usage;
      const perBatch = (key) =>
        batches.map((batch) => `${batch.name}`).join(', ') || 'No active batch';

      return [
        {
          key: 'transport',
          icon: 'directions_bus',
          color: '#1e88e5',
          tint: '#e3f2fd',
          total: transport.total,
          label: 'Transport Users',
          detail: perBatch('transport'),
        },
        {
          key: 'food',
          icon: 'restaurant',
          color: '#43a047',
          tint: '#e8f5e9',
          total: food.total,
          label: 'Food Users (Customized)',
          detail: perBatch('food'),
        },
      ];
    },
  },

  mounted() {
    this.fetch();
  },

  methods: {
    fetch() {
      this.loading = true;
      this.$rest
        .get('/api/dashboard/service-usage-count')
        .then(({ data }) => {
          this.usage = data;
        })
        .catch(() => { })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.service-usage {
  .service-card {
    background-color: #fff;
    padding: 18px 16px;
    border-radius: 14px;
    margin-bottom: 20px;

    .icon-box {
      display: flex;
      align-items: flex-start;

      .material-icons {
        padding: 10px;
        display: inline-block;
        border-radius: 10px;
        margin-right: 12px;
      }

      .text {
        flex: 1;
        color: #000;

        h1 {
          font-size: 17px;
          font-weight: 700;
          line-height: 1.4;
        }

        p {
          font-size: 13px;
          margin: 0;
        }

        small {
          color: #888;
          font-size: 11px;
        }
      }

      .refresh {
        margin: -4px -6px 0 0;
      }
    }
  }
}
</style>
